import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import Img from 'gatsby-image';
import { openTab } from '../../utils/open-tab';
import { ProductImage } from '../ProductImage';

type Props = {
  fileName: string;
  alt: string;
  affiliateUrl: string;
};

type File = {
  fileName: string;
};
type Node = {
  file: File;
};
const TableImage: React.FC<Props> = ({ fileName, alt, affiliateUrl }) => {
  const {
    allContentfulAsset: { nodes },
  } = useStaticQuery(graphql`
    {
      allContentfulAsset {
        nodes {
          fixed(width: 180) {
            ...GatsbyContentfulFixed
          }
          file {
            fileName
          }
        }
      }
    }
  `);

  const image = nodes.find(({ file }: Node) => file.fileName === fileName);
  return (
    <ProductImage
      fixed={image.fixed}
      alt={alt}
      onClick={(e) => openTab(e, affiliateUrl)}
    />
  );
};

export default TableImage;
